import { useEffect, useCallback } from "react";

import useLatestValue from "./useLatestValue";

const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    document.addEventListener("click", onDocumentClick);

    return () => {
      document.removeEventListener("click", onDocumentClick);
    };
  }, []);

  const latestHandlerRef = useLatestValue(handler);

  const onDocumentClick = useCallback(
    e => {
      const target = e.target;
      if (ref.current && !ref.current.contains(target)) {
        latestHandlerRef?.current?.(e);
      }
    },
    [latestHandlerRef]
  );
};

export default useOnClickOutside;
